const { createHigherOrderComponent } = wp.compose;
const { Fragment } = wp.element;
const { addFilter } = wp.hooks;
import classnames from 'classnames';

const enableSpacingControlOnBlocks = [
	'gutenify/info-box',
];
/**
 * Create HOC to add spacing control to inspector controls of block.
 */
const withSpacingControl = createHigherOrderComponent( ( BlockEdit ) => {
	return ( props ) => {
		// Do nothing if it's another block than our defined ones.
		if ( ! enableSpacingControlOnBlocks.includes( props.name ) ) {
			return (
				<BlockEdit { ...props } />
			);
		}

		// add has-spacing-xy class to block
		if ( ! props.attributes.blockClientId && ( props.attributes.className && ! props.attributes.className.includes( 'has-shadow-dark' ) ) ) {
			props.attributes.className = classnames( 'has-shadow-dark', props.attributes.className );
		}

		return (
			<Fragment>
				<BlockEdit { ...props } />
			</Fragment>
		);
	};
}, 'withSpacingControl' );

addFilter( 'editor.BlockEdit', 'extend-block-example/with-spacing-control', withSpacingControl );
